import Cookies from 'js-cookie';

function readDecisionsCookie(): Record<string, unknown> {
    const raw = Cookies.get('x-petm-decisions') ?? '{}';
    try {
        return JSON.parse(raw) as Record<string, unknown>;
    } catch {
        return {};
    }
}

function readStringFlag(decisions: Record<string, unknown>, key: string): string | undefined {
    const value = decisions[key];
    return typeof value === 'string' ? value : undefined;
}

/**
 * Mirrors `libs/experience-api/src/server-exports/cart-routes/fetchCart.ts#getCartApiBaseUrl`.
 *
 * - `v2/` when autoship decision is `crawl`
 */
export function getCartsPathPrefix(): string {
    const decisions = readDecisionsCookie();
    const autoshipType = readStringFlag(decisions, 'ff_autoship');

    const cartApiVersionPrefix = autoshipType === 'crawl' ? 'v2/' : '';

    return cartApiVersionPrefix;
}

export function getCartDelInstrQueryValue(): 'true' | 'false' {
    const decisions = readDecisionsCookie();
    return decisions.cart_del_instr === true ? 'true' : 'false';
}

export function appendCartDelInstrQuery(pathname: string): string {
    const [path, ...queryParts] = pathname.split('?');
    const params = new URLSearchParams(queryParts.join('?'));
    params.set('cartDelInstr', getCartDelInstrQueryValue());
    return `${path}?${params.toString()}`;
}
